import React from "react";
import img1 from "../../Assets/Images/InvestmentCorner1.png";
import InvestmentCornerPartTwo from "../../components/InvestmentCorner/InvestmentCornerPartTwo";
import SimpleBanner from "../../components/common/Banner";

const InvestmentCorner = () => {
  return (
    <div className="overflow-hidden">
      <SimpleBanner name_primary="Investment" name_secondary="Corner" />
      <div className="bg-gray-50 py-4 md:py-16 px-4 sm:px-6 lg:px-8">
        <div className="w-full mx-auto">
          <div className="flex flex-col-reverse lg:flex-row gap-12 items-center">
            {/* Left Side - Image */}
            <div className="rounded-lg w-full lg:w-1/2">
              <img src={img1} alt="" className="h-auto md:h-[550px] w-full object-cover rounded-lg" />
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6 w-full lg:w-1/2">
              <div>
                <h2 className="text-xl sm:text-2xl md:text-3xl xl:text-4xl font-semibold text-gray-900 mb-4">
                  <span className="text-[#FF5A3C]">Investment</span>{" "}
                  <span className="text-gray-900">Corner</span>
                </h2>

                <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify mb-6">
                  Unlock The Potential Of Smart Real Estate Investment With
                  Covenants. Whether You're Looking For A Dream Home Or A
                  High-Return Asset, Our Premium Properties Offer Security,
                  Growth, And Long-Term Value. With Strategic Locations, Modern
                  Designs, And Sustainable Features, We Ensure That Every
                  Investment Is A Step Toward A Prosperous Future.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-2 sm:p-8 shadow-xl border-l-4 border-[#FF5A3C] relative overflow-hidden">
                <p className="text-gray-800 font-semibold text-sm sm:text-lg md:text-xl leading-relaxed relative z-10 ml-2">
                  We don’t just construct buildings — we build trust, we build dreams.
                </p>
              </div>

              <div className="space-y-4">
                <p className="text-gray-600 text-sm sm:text-base md:text-md leading-relaxed text-justify">
                  Discover The Smart Way To Invest In Real Estate With
                  Covenants. Whether You're Searching For Your Perfect Home Or A
                  Profitable Asset, Our Premium Properties Deliver Unmatched
                  Value, Long-Term Growth, And Peace Of Mind. From Residential
                  Complexes To Commercial Spaces, Each Project Is Strategically
                  Located In Prime Areas, Every Project We Develop Ensures A
                  Solid Investment And A Prosperous Future.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <InvestmentCornerPartTwo />
    </div>
  );
};

export default InvestmentCorner;
